module.exports = __webpack_public_path__ + "static/media/mcm_3202.dcb07e48.ico";